// extracted by mini-css-extract-plugin
export default {"error":"styles_error__QXhZR","troubleLoggingIn":"styles_troubleLoggingIn__-l+X8","signUp":"styles_signUp__wjXIs","signUpContainer":"styles_signUpContainer__am9Km"};